import React, { lazy, Suspense, useEffect, useState, useCallback, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { Panel, Row, Form, Button, FormControl } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { navigate } from 'raviger';
import _ from 'lodash';
import moment from 'moment';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import withForm from '../../hoc/withForm';
import OptionsHelper from '../../lib/OptionsHelper';
import { Multiselect } from 'multiselect-react-dropdown';

import { useAlertStore } from '../../store/providers/Alert';
import { useActivityPlansStore } from '../../store/providers/ActivityPlans';
import { useActivityTemplateStore } from '../../store/providers/ActivityTemplates';
import Permission from '../../components/Permission/Permission';
import * as constants from '../../constants';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import validations from './ActivityPlan_Validations';
import './ActivityPlan.css';

import Spinner from '../../components/Spinner/Spinner';
import { columns, sorting } from './ActivityTemplatesSchema';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const InputCollection = lazy(() => import('../../components/InputCollection/InputCollection'));
const BaseList = React.lazy(() => import('../../components/Lists/BaseList/BaseList'));
const operatorValues = [
    {
        "id": 302,
        "name": "after"
    },
    {
        "id": 303,
        "name": "before"
    },
];

function ActivityPlan(props) {
    const dispatch = useDispatch();

    const { addAlert } = useAlertStore();
    const { selectRecord, newRecord, createRecord, updateRecord, listCategories, data, clearData } = useActivityPlansStore();
    const { listRecords: listActivityTemplates, deleteRecord, duplicateRecord, data: activityTemplateData } = useActivityTemplateStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const pagePermission = constants.PERMISSION_CONTENT_ACTIVITYPLANS_ACTIVITYPLAN;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [listTemplateData, setListTemplateData] = useState([]);
    const [listCategoryData, setListCategoryData] = useState([]);
    const [listCategoryOptions, setListCategoryOptions] = useState([]);

    const [categoryId, setCategoryId] = useState('');
    const subCategoryDropdown = useRef(null);
    const [listSubCategoryOptions, setListSubCategoryOptions] = useState();
    const [listSubCategoryData, setListSubCategoryData] = useState();
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);

    const [planName, setPlanName] = useState('');
    const [defaultStartDate, setDefaultStartDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const allSubCategorySelectOption = 'all';

    const cancelledHandler = () => {
        navigate('/activityPlans');
    };

    const submittedHandler = (e) => {
        e.preventDefault();

        let subCategoryIds = GetSubCategoryIds(categoryId, selectedSubCategories);

        props.formData.SelectedSubCategories = subCategoryIds;

        var valid = props.formValidate(validations);

        if (valid) {
            props.formSubmitted();
            isNew ? createRecord(props.formData) : updateRecord({
                Id: props.formData.id,
                Name: props.formData.name,
                Description: props.formData.description,
                StartDate: props.formData.startDate,
                EndDate: props.formData.endDate,
                CategoryId: props.formData.categoryId,
                SelectedSubCategories: subCategoryIds,
                FranchiseId: null,
                IsDeleted: props.formData.isDeleted
            });
        }
        navigate('/activityPlans');
    };

    const selectSubCategoryHandler = (list, item, categoryId) => {
        let isAllSelected = item.name.toLowerCase() === allSubCategorySelectOption;
        if (!isAllSelected && list.some(x => x.name.toLowerCase() == allSubCategorySelectOption)) {
            list = list.filter(x => x.id !== 0);
        }
        else if (isAllSelected && list.length > 1) {
            list = list.filter(x => x.id === 0);
        }

        setSelectedSubCategories(list);

        let subCategoryIds = [];
        if (isAllSelected) {
            var allSubcategoryItems = GetSubCategoriesByCategoryId(categoryId);
            allSubcategoryItems.filter(x => x.name.toLowerCase() !== allSubCategorySelectOption).forEach((subCategory) => subCategoryIds.push(subCategory.id));
        }
        else {
            list.forEach((subCategory) => subCategoryIds.push(subCategory.id));
        }

        props.formChanged('SelectedSubCategories', (isEmpty(subCategoryIds) ? [] : subCategoryIds.join(',')));
    };

    function GetSubCategoriesByCategoryId(categoryId) {
        switch (parseInt(categoryId)) {
            case 2:
                return listSubCategoryData.agent;
            case 5:
                return listSubCategoryData.listing;
            case 8:
                return listSubCategoryData.rental;
            case 6:
                return listSubCategoryData.sale;
            default:
                return [];
        }
    }

    const removeSubCategoryHandler = (list, _item) => {
        setSelectedSubCategories(list);

        let subCategoryIds = [];

        list.forEach((subCategory) => subCategoryIds.push(subCategory.id));
        props.formChanged('SelectedSubCategories', (isEmpty(subCategoryIds) ? [] : subCategoryIds.join(',')));
    };

    const selectedHandler = (activityTemplate) => {
        navigate(`/activityPlan/template/edit/${activityTemplate.id}`);
    };

    const addedHandler = (activityPlan) => {

        if (isEmpty(props.formData.description) && !isEmpty(planName)) {
            props.formChanged('description', planName);
        }

        let subCategoryIds = GetSubCategoryIds(categoryId, selectedSubCategories);

        props.formData.SelectedSubCategories = subCategoryIds;

        var valid = props.formValidate(validations);
        if (valid) {
            if (!isEmpty(activityPlan.activityPlanId)) {
                navigate(`/activityPlan/template/new/${activityPlan.activityPlanId}`);
            } else {
                if (!isEmpty(props.formData.endDate)) {
                    navigate(`/activityPlan/template/new/${props.formData.name}/${props.formData.description}/${props.formData.categoryId}/${subCategoryIds.join('-')}/${props.formData.startDate}/${props.formData.endDate}`);
                } else {
                    navigate(`/activityPlan/template/new/${props.formData.name}/${props.formData.description}/${props.formData.categoryId}/${subCategoryIds.join('-')}/${props.formData.startDate}`);
                }
            }
        }
    };

    const copiedHandler = (activityTemplate) => {
        duplicateRecord({ activityTemplateId: activityTemplate.id });
    };

    const deletedHandler = (activityTemplate) => {
        deleteRecord({ activityTemplateId: activityTemplate.id });
    };

    const refreshedHandler = () => {
        if (props.activityPlanId) {
            listActivityTemplates({ activityPlanId: props.activityPlanId });
        }
    };

    const categoryChanged = useCallback((categoryId) => {
        setSelectedSubCategories([]);
        setCategoryId(categoryId);
        props.formChanged('SelectedSubCategories', ([]));

        switch (parseInt(categoryId)) {
            case 2:
                setListSubCategoryOptions(listSubCategoryData.agent);
                break;
            case 5:
                setListSubCategoryOptions(listSubCategoryData.listing);
                break;
            case 8:
                setListSubCategoryOptions(listSubCategoryData.rental);
                break;
            case 6:
                setListSubCategoryOptions(listSubCategoryData.sale);
                break;
            default:
                setListSubCategoryOptions();
                break;
        }
    }, [listSubCategoryData, setListSubCategoryOptions]);

    useEffect(() => {
        if (!isEmpty(activityTemplateData)) {
            if ((activityTemplateData.scope === 'delete' || activityTemplateData.scope === 'dupe') && activityTemplateData.status === 'success') {
                setIsLoaded(false);
                setIsMounted(false);
                if (activityTemplateData.scope === 'dupe') {
                    navigate('/activityPlan/template/edit/' + activityTemplateData.body.id);
                }
            }
        }
    }, [
        activityTemplateData
    ]);

    useEffect(() => {
        if (!isEmpty(data)) {
            if ((data.scope === 'create' || data.scope === 'update')
                && data.status === 'success') {
                setIsNew(false);
                navigate(`/activityPlan/edit/${data.body.id}`);
            }

            if (!isLoaded && isMounted &&
                (data.scope === 'select' || data.scope === 'new') && data.status === 'success') {

                if (data.body && data.body.id) {
                    if (!_.isEmpty(data.body.startDate)) { data.body.startDate = moment(data.body.startDate).format('YYYY-MM-DD'); }
                    if (!_.isEmpty(data.body.endDate)) { data.body.endDate = moment(data.body.endDate).format('YYYY-MM-DD'); }

                    props.formChanged('startDate', data.body.startDate);
                    setDefaultStartDate(data.body.startDate);
                    categoryChanged(data.body.categoryId);

                    if (!isEmpty(data.body.subCategories)) {
                        const options = data.body.subCategories.map((subCategory) => {
                            let name = '';
                            switch (subCategory.subCategoryId) {
                                case 318:
                                    name = "Residential";
                                    break;
                                case 319:
                                    name = "Commercial Land";
                                    break;
                                case 320:
                                    name = "New Build";
                                    break;
                                case 321:
                                    name = "Commercial";
                                    break;
                                case 322:
                                    name = "HUD";
                                    break;
                                case 323:
                                    name = "VA";
                                    break;
                                case 324:
                                    name = "Business Opportunity";
                                    break;
                                case 325:
                                    name = "Multi Family";
                                    break;
                                case 327:
                                    name = "Active";
                                    break;
                                case 328:
                                    name = "Severed";
                                    break;
                                case 433:
                                    name = "Residential Land";
                                    break;
                                case 636:
                                    name = "Commercial Rental";
                                    break;
                                case 637:
                                    name = "Residential Rental";
                                    break;
                                case 660:
                                    name = "Acquisition Agent";
                                    break;
                            }
                            return { id: subCategory.subCategoryId, name: name }
                        });

                        var allFromSubCategoryList = GetSubCategoriesByCategoryId(data.body.categoryId);
                        var subCategoryIds = allFromSubCategoryList.filter(x => x.name.toLowerCase() !== allSubCategorySelectOption).map(i => i.id);
                        var currentOptionsIds = options.map(i => i.id);

                        if (JSON.stringify(currentOptionsIds) == JSON.stringify(subCategoryIds)) {
                            let allOption = allFromSubCategoryList.filter(x => x.name.toLowerCase() === allSubCategorySelectOption);
                            setSelectedSubCategories(allOption);
                        }
                        else {
                            setSelectedSubCategories(options);
                        }
                    }
                    const formattedData = data.body.activityTemplates.map((item) => {
                        let triggerName = item.triggerFieldType && !isEmpty(item.triggerFieldType.displayName)
                            ? item.triggerFieldType.displayName.replace(/([A-Z])/g, ' $1').trim()
                            : '';
                        let formattedDisplayName = '';
                        if (item.executionTypeId === constants.ACTIVITYPLANEXECUTIONTYPE_PERFORMIMMEDIATELY) {
                            formattedDisplayName = 'On ' + triggerName;
                        } else {
                            if (item.dueDays == null) {
                                formattedDisplayName = item.precedingActivity && !isEmpty(item.precedingActivity.name)
                                    ? 'After ' + item.precedingActivity.name
                                    : '-';
                            } else {
                                let operator = operatorValues.find(operator => operator.id === item.operatorId);
                                let operatorName = operator ? operator.name : '';
                                formattedDisplayName = operatorName.charAt(0).toUpperCase() + operatorName.slice(1) + ' ' + triggerName;
                            }
                        }

                        return {
                            ...item,
                            triggerFieldType: {
                                ...item.triggerFieldType,
                                formattedDisplayName // Add formattedDisplayName inside triggerFieldType
                            }
                        };
                    });
                    // Now set the formatted data to state
                    setListTemplateData(formattedData);
                    dispatch(breadcrumbAddRoute({
                        key: 'edit-activityPlan',
                        text: data.body.name,
                        path: {
                            event: () => {
                                navigate(`/activityPlan/edit/${data.body.id}`);
                            }
                        }
                    }));
                } else {
                    dispatch(breadcrumbAddRoute({
                        key: 'new-activityPlan',
                        text: 'New Activity Plan',
                        path: {
                            event: () => {
                                navigate(`/activityPlan/new`);
                            }
                        }
                    }));
                }

                props.formInitialize(data.body);
                setIsLoaded(true);
            }

            if (!isNew && (data.scope === 'new' && data.status === 'success')) {
                setIsNew(true);
            }

            if (data.status === 'success' && data.scope === 'listcategories') {
                setListCategoryData(data.body);
            }

            setIsBusy(
                data.status === 'processing' && (data.scope === 'edit' || data.scope === 'update' || data.scope === 'create')
            );
        }

    }, [
        data,
        props,
        isNew,
        addAlert,
        isLoaded,
        isMounted,
        clearData,
        categoryChanged,
        setListCategoryData,
        dispatch
    ]);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        setListSubCategoryData({
            listing: [
                {
                    id: 0,
                    name: "All",
                    description: "All",
                },
                {
                    id: 318,
                    name: "Residential",
                    description: "Residential",
                },
                {
                    id: 433,
                    name: "Residential Land",
                    description: "ResidentialLand",
                },
                {
                    id: 319,
                    name: "Commercial Land",
                    description: "CommercialLand",
                },
                {
                    id: 320,
                    name: "New Build",
                    description: "NewBuild",
                },
                {
                    id: 321,
                    name: "Commercial",
                    description: "Commercial",
                },
                {
                    id: 322,
                    name: "HUD",
                    description: "HUD",
                },
                {
                    id: 323,
                    name: "VA",
                    description: "VA",
                },
                {
                    id: 324,
                    name: "Business Opportunity",
                    description: "BusinessOpp",
                },
                {
                    id: 325,
                    name: "Multi Family",
                    description: "MultiFamily",
                },
                {
                    id: 636,
                    name: "Commercial Rental",
                    description: "CommercialRental",
                },
                {
                    id: 637,
                    name: "Residential Rental",
                    description: "ResidentialRental",
                }],
            sale: [
                {
                    id: 0,
                    name: "All",
                    description: "All",
                },
                {
                    id: 318,
                    name: "Residential",
                    description: "Residential",
                },
                {
                    id: 433,
                    name: "Residential Land",
                    description: "ResidentialLand",
                },
                {
                    id: 319,
                    name: "Commercial Land",
                    description: "CommercialLand",
                },
                {
                    id: 320,
                    name: "New Build",
                    description: "NewBuild",
                },
                {
                    id: 321,
                    name: "Commercial",
                    description: "Commercial",
                },
                {
                    id: 322,
                    name: "HUD",
                    description: "HUD",
                },
                {
                    id: 323,
                    name: "VA",
                    description: "VA",
                },
                {
                    id: 324,
                    name: "Business Opportunity",
                    description: "BusinessOpp",
                },
                {
                    id: 325,
                    name: "Multi Family",
                    description: "MultiFamily",
                }],
            agent: [
                {
                    id: 0,
                    name: "All",
                    description: "All",
                },
                {
                    id: 327,
                    name: "Active",
                    description: "Active",
                },
                {
                    id: 328,
                    name: "Severed",
                    description: "Severed",
                },
                {
                    id: 660,
                    name: "Acquisition Agent",
                    description: "AcquisitionAgent",
                }],
            rental: [
                {
                    id: 0,
                    name: "All",
                    description: "All",
                },
                {
                    id: 636,
                    name: "Commercial Rental",
                    description: "CommercialRental",
                },
                {
                    id: 637,
                    name: "Residential Rental",
                    description: "ResidentialRental",
                }]
        });

        dispatch(breadcrumbAddRoute({
            key: 'activityPlans', text: 'Activity Plans', path: {
                event: () => {
                    dispatch(breadcrumbRemoveRoute(2));
                    navigate('/activityPlans');
                }
            }
        }));

        listCategories();

        if (!isNaN(props.activityPlanId)) {
            selectRecord({ activityPlanId: props.activityPlanId });
            setIsNew(false);
        } else {
            setIsNew(true);
            newRecord();

        }
        setIsMounted(true);

    }, [
        props,
        hasPermission,
        isMounted,
        newRecord,
        selectRecord,
        listCategories,
        dispatch
    ]);

    useEffect(() => {
        if (!_.isEmpty(listCategoryData)) {
            const categoryOptions = listCategoryData && listCategoryData.map(category => {
                return {
                    id: category.id,
                    name: category.name,
                    description: ''
                }
            });
            setListCategoryOptions(OptionsHelper({ list: categoryOptions, nameField: 'name', includeBlank: true }));
        }
    }, [listCategoryData]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    useEffect(() => {
        props.formChanged('startDate', defaultStartDate)
    }, [defaultStartDate]);

    useEffect(() => {
        if (props.formData.startDate === undefined) {
            props.formChanged('startDate', moment(new Date()).format('YYYY-MM-DD'));
        }
    }, [props.formData]);

    function GetSubCategoryIds(categoryId, selectedSubCategories) {
        let ids = [];
        if (selectedSubCategories.some(x => x.name.toLowerCase() === allSubCategorySelectOption)) {
            ids = GetSubCategoriesByCategoryId(categoryId).filter(x => x.name.toLowerCase() !== allSubCategorySelectOption).map((selectedSubCategory) => {
                return selectedSubCategory.id;
            });
        }
        else {
            ids = selectedSubCategories.map((selectedSubCategory) => {
                return selectedSubCategory.id;
            });
        }
        return ids;
    }

    return (
        <>
            <SideMenu activeKey="content" />
            <div className="content-body">

                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isLoaded
                    ?
                    <Suspense fallback={<Spinner text="Loading Activity Plan..." />}>
                        {
                            <>

                                <div style={{ paddingRight: '15px' }}>
                                    {!isNew &&
                                        <PageHeader title={"Edit Activity Plan: " + props.formData['name']} />
                                    }
                                    {isNew &&
                                        <PageHeader title={"New Activity Plan"} />
                                    }
                                    <Panel>
                                        <Panel.Body>
                                            <Form onSubmit={(e) => submittedHandler(e)}>
                                                <Row>
                                                    <div className="col-md-6">
                                                        <InputCollection
                                                            required
                                                            labelText="Name"
                                                            errorMessage={props.formValidationCheck('name')}
                                                        >
                                                            <FormControl
                                                                id="name"
                                                                name="name"
                                                                maxLength={100}
                                                                onChange={(e) => {
                                                                    props.formChanged(e.target.name, e.target.value);
                                                                    setPlanName(e.target.value);
                                                                }}
                                                                onBlur={(e) => {
                                                                    const { formData, formChanged } = props;
                                                                    if (!formData.description && e.target.value) {
                                                                        formChanged('description', e.target.value);
                                                                    }
                                                                }}
                                                                defaultValue={props.formData['name'] || ''}
                                                                disabled={isBusy}
                                                            />
                                                        </InputCollection>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <InputCollection
                                                            required
                                                            labelText="Description"
                                                            errorMessage={props.formValidationCheck('description')}
                                                        >
                                                            <FormControl
                                                                id="description"
                                                                name="description"
                                                                onChange={(e) => {
                                                                    props.formChanged(e.target.name, e.target.value);
                                                                }}
                                                                defaultValue={props.formData['description'] || ''}
                                                                disabled={isBusy}
                                                            />
                                                        </InputCollection>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <div className="col-md-6">
                                                        <InputCollection
                                                            required
                                                            labelText="Plan Type"
                                                            errorMessage={props.formValidationCheck('categoryId')}
                                                        >
                                                            <FormControl
                                                                id="categoryId"
                                                                componentClass="select"
                                                                onChange={(e) => { categoryChanged(e.target.value); props.formChanged(e.target.id, e.target.value); }}
                                                                defaultValue={props.formData['categoryId']}
                                                                disabled={isBusy}>
                                                                {listCategoryOptions}
                                                            </FormControl>
                                                        </InputCollection>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {categoryId &&
                                                            <InputCollection required labelText="Plan Category" errorMessage={props.formValidationCheck('SelectedSubCategories')}>
                                                                <Multiselect
                                                                    options={listSubCategoryOptions}
                                                                    displayValue="name"
                                                                    required
                                                                    disabled={isBusy}
                                                                    placeholder="Select Subcategory..."
                                                                    emptyRecordMsg="No Subcategory Available"
                                                                    selectedValues={selectedSubCategories}
                                                                    ref={subCategoryDropdown}
                                                                    avoidHighlightFirstOption={true}
                                                                    closeOnSelect={false}
                                                                    id="SelectedSubCategories"
                                                                    onSelect={(list, item) => selectSubCategoryHandler(list, item, categoryId)}
                                                                    onRemove={(list, item) => removeSubCategoryHandler(list, item)}
                                                                />
                                                            </InputCollection>
                                                        }
                                                    </div>
                                                </Row>
                                                <Row style={{ marginBottom: '3em' }}>
                                                    <div className="col-md-3">
                                                        <InputCollection
                                                            required
                                                            labelText="Start Date"
                                                            errorMessage={props.formValidationCheck('startDate')}
                                                        >
                                                            <FormControl
                                                                id="startDate"
                                                                name="startDate"
                                                                type="date"
                                                                onBlur={(e) => {
                                                                    props.formChanged(e.target.name, e.target.value);
                                                                    setDefaultStartDate(e.target.value);
                                                                }}
                                                                defaultValue={defaultStartDate}
                                                                maxLength={10}
                                                                disabled={isBusy}
                                                            />
                                                        </InputCollection>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <InputCollection labelText="End Date" >
                                                            <FormControl
                                                                id="endDate"
                                                                name="endDate"
                                                                type="date"
                                                                onBlur={(e) => props.formChanged(e.target.id, e.target.value)}
                                                                defaultValue={props.formData['endDate'] || ''}
                                                                maxLength={10}
                                                                disabled={isBusy}
                                                            />
                                                        </InputCollection>
                                                    </div>
                                                </Row>
                                            </Form>

                                            <>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <Panel>
                                                            <Panel.Heading>
                                                                <Panel.Title componentClass="h3">Activities</Panel.Title>
                                                            </Panel.Heading>
                                                            <Panel.Body>
                                                                <BaseList
                                                                    compType="Activities"
                                                                    listData={listTemplateData}
                                                                    isBusy={isBusy}
                                                                    sorting={sorting}
                                                                    columns={columns}
                                                                    hideCopy={false}
                                                                    hidePrint={true}
                                                                    hideFilter={false}
                                                                    activeValue={false}
                                                                    activeField={"isDeleted"}
                                                                    added={() => addedHandler(props)}
                                                                    selected={(activityTemp) => selectedHandler(activityTemp)}
                                                                    copied={(activityTemp) => copiedHandler(activityTemp)}
                                                                    deleted={(activityTemp) => deletedHandler(activityTemp)}
                                                                    refreshed={() => refreshedHandler()}
                                                                    permissionEdit={canEdit}
                                                                />
                                                            </Panel.Body>
                                                        </Panel>
                                                    </div>
                                                </div>
                                            </>

                                            <hr className="form-divider" />

                                            <div className="form-action-buttons">
                                                <Button bsStyle="default" onClick={() => cancelledHandler()} className="button-group-margin" disabled={isBusy}>
                                                    <i className="fa fa-undo button-icon"></i>
                                                    Back to List
                                                </Button>
                                                <Button bsStyle="danger" variant="danger" onClick={(e) => submittedHandler(e)} type="submit" className="button-group-margin" disabled={!canEdit || isNew || isBusy}>
                                                    <i className="fa fa-save button-icon"></i>
                                                    {isBusy ? 'Saving...' : (isNew ? 'Create' : 'Save & Exit')}
                                                </Button>
                                            </div>
                                        </Panel.Body>
                                    </Panel>
                                </div>

                            </>
                        }
                    </Suspense>
                    : <Spinner text="Loading Activity Plan..." />
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(withForm(ActivityPlan)));
